// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import api from './request/http.js'
// import './assets/style/theme/index.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style/init.css'
import './assets/style/main.less'
import './assets/style/wmy.css'
import './assets/font/iconfont.css'
import './assets/font/iconfont.js'
import VuePreview from 'vue-preview'

Vue.prototype.$ajax = api; // 接口管理
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VuePreview);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router, store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js